export class ImageModel {
  imageData: string;
  fileName: string;
  url: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/image.model.ts